export enum StatusName {
  Doing = 'Đang làm',
  Done = 'Đã làm',
}

export const status = [
  { label: StatusName.Doing, value: 1 },
  { label: StatusName.Done, value: 2 },
];

export const REPORT_PAGE_LIMIT = 10;
export const DEFAULT_REPORT_PAGE = 1;

export const TEXT_MAX_LENGTH = 255;

export enum DateTimeFormat {
  DD_MM_YYYY_DASH = 'DD/MM/YYYY',
  DD = 'DD',
  MM = 'MM',
  YYYY = 'YYYY',
  HH_MM = 'HH:mm',
  YYYY_MM_DD_HH_MM_SLASH = 'YYYY-MM-DD HH:mm'
}


export enum SEVERITY_NOTIFICATION {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}